import React, { Component } from 'react';
import { ParametersSailingProvider, CompactItineraryCalendarContainer, ToDosContainer } from 'cclr-booked';
import { Spinner } from 'cclr-huge-ui';
import { Error } from './error';

import './todoPlanner.scss';

/* eslint-disable */
export class TodoPlanner extends Component {
  constructor(props) {
    super(props);
    this.state = { sailDate: "", shipCode: "" }
  }

  componentDidMount() {
    if ($('#sailDate').length >= 0) {
      const currentSailDate = $('#sailDate')[0].value;
      const currentShipCode = $('#shipCode')[0].value;
      this.setState({
        sailDate: currentSailDate,
        shipCode: currentShipCode
      })
    }
  }

  render() {
    if (this.state.sailDate && this.state.shipCode) {
      return (
        <ParametersSailingProvider
          sailDate={this.state.sailDate}
          shipCode={this.state.shipCode}
          renderLoading={() => <Spinner />}
          renderError={() => <Error />}
        >
          {(sailing, sailings) => {
            return (
              <div className="home-container">
                <section className="home-sidebar">
                  <ToDosContainer
                    sailing={sailing}
                    isCompactMode={true}
                    expandedMobileMode={false}
                  />
                  <CompactItineraryCalendarContainer
                    shipCode={sailing.itinerary.shipCode}
                    sailDate={sailing.itinerary.sailDate}
                  />
                </section>
                {/* <section className="home-main">
                  <ToDosContainer
                    sailing={sailing}
                    isCompactMode={false}
                    expandedMobileMode={true}
                  />
                </section> */}
              </div>
            );
          }}
        </ParametersSailingProvider>
      );
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./reactComponents/components/todoPlanner/TodoPlanner.jsx